import { ImportType } from 'library/ts/model/enums/config/ImportType';
import { AssetEmbedType } from 'library/ts/model/enums/content/AssetEmbedType';
import { Country } from 'library/ts/model/enums/geo/Country';
import { SubscriberPackageDelimiter } from 'library/ts/model/user/SubscriberPackageDelimiter';
import { SubscriberPackageKey } from 'library/ts/model/user/SubscriberPackageKey';
import { SubscriberPackageValue } from 'library/ts/model/user/SubscriberPackageValue';
import { UserType } from 'library/ts/model/user/UserType';
import { UserTypeLibrary } from 'library/ts/model/user/UserTypeLIbrary';
import { ImportVO } from 'library/ts/model/vo/ImportVO';
import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { AdSDK } from 'tag/ts/tag/model/type/ads/AdSDK';
import { PlayerType } from 'tag/ts/tag/model/type/PlayerType';
export class TagUtilities extends AbstractTagClass {
    constructor(argument) {
        super({
            ...argument,
            name: 'TagUtilities'
        });
    }
    getUserType = (userStatus = this?.params?.USER?.userStatus) => {
        if (this.utils.Type.isEmpty(userStatus))
            return UserType.ANON;
        let outputUserType = UserType.ANON;
        const isUserTypePresent = (paramsVOUserStatus = `${SubscriberPackageKey.ANON}${SubscriberPackageDelimiter.EMPTY}${SubscriberPackageValue.EMPTY}`, oneUserTypeVariants = []) => {
            for (let i = 0; i < oneUserTypeVariants.length; i++) {
                if (paramsVOUserStatus.indexOf(oneUserTypeVariants[i]) > -1)
                    return true;
            }
            return false;
        };
        for (const oneUserType of Object.keys(UserTypeLibrary)) {
            if (isUserTypePresent(userStatus, UserTypeLibrary[oneUserType]) === true) {
                outputUserType = oneUserType;
                break;
            }
        }
        this?.logger?.log('getUserType: return value:', outputUserType);
        return outputUserType;
    };
    isInternationalContext = (tag = this.tag) => {
        let international = false;
        const TAG_API = tag?.controller?.tagAPI?.OUT;
        let checkIntlContext = true;
        if (!this.utils.Type.isEmpty(this.params.CONTENT?.country)) {
            switch (this.params.CONTENT.country) {
                case Country.LOCALHOST:
                case Country.US:
                    checkIntlContext = false;
                    break;
            }
        }
        if (checkIntlContext === true) {
            international = TAG_API?.checkContext({ country: this.params.CONTENT.country });
            if (this.utils.Type.isUndefined(international) === true)
                international = false;
        }
        return international;
    };
    processImports = (imports = []) => {
        const runtimeVO = window.SmartTag.runtimeVO;
        imports.forEach((importIO) => {
            if (runtimeVO.top.ssl)
                importIO.url = this.utils.URL.toHTTPS(importIO.url);
            if (runtimeVO?.readyCallback?.payload?.relative === true)
                importIO.url = this.utils.URL.convertToRelative(importIO?.url);
        });
        return imports;
    };
    getImports = (tag = this.tag) => {
        const runtimeVO = this.runtimeVO;
        const callbackImports = runtimeVO?.readyCallback?.payload?.imports;
        const paramsVO = tag?.params;
        const importsModule = tag?.model?.config?.tag?.Imports?.params;
        let dependencies = [];
        const adSetupInfo = tag?.model?.adUtilities?.adSetupInfo();
        const adImportable = adSetupInfo?.sdk?.module;
        if (adSetupInfo?.sdk?.type === AdSDK.IMA && this.utils.Type.isEmpty(paramsVO?.AD?.FW?.FMS)) {
            paramsVO.AD.SDK.preload = true;
        }
        if (paramsVO?.AD?.SDK?.preload === true
            &&
                this.utils.Type.isDefined(adImportable)
            &&
                !this.utils.Import.alreadyPresent(adImportable.url.regular, adImportable.namespace)) {
            dependencies.push(new ImportVO(ImportType.SCRIPT, adImportable.url.regular, adImportable.namespace, window));
        }
        if (paramsVO.SKIN.enabled === true && tag?.view?.playerType === PlayerType.CHROMELESS) {
            const skinAppCSSURL = importsModule.smart_tag.skin_css.url.regular;
            const skinAppURL = importsModule.smart_tag.skin.url.regular;
            const skinAppNamespace = importsModule.smart_tag.skin.namespace;
            if (!this.utils.Import.alreadyPresent(skinAppCSSURL, undefined, !this.utils.URL.valid(callbackImports?.smart_tag?.skin_css?.url?.regular))) {
                dependencies.push(new ImportVO(ImportType.STYLE, this.utils.URL.addCacheToken(skinAppCSSURL, runtimeVO.debug.cacheBust)));
            }
            if (!this.utils.Import.alreadyPresent(skinAppURL, skinAppNamespace, !this.utils.URL.valid(callbackImports?.smart_tag?.skin?.url?.regular))) {
                dependencies.push(new ImportVO(ImportType.SCRIPT, this.utils.URL.addCacheToken(skinAppURL, runtimeVO.debug.cacheBust), skinAppNamespace, window));
            }
        }
        dependencies = this.processImports(dependencies);
        return dependencies;
    };
    normalizeParams = (params) => {
        if (this.utils.Type.isObject(params?.CONTENT) && !this.utils.Type.isEmpty(params?.CONTENT)) {
            [
                AssetEmbedType.PID,
                AssetEmbedType.CID,
                AssetEmbedType.ASSET_URL
            ].forEach((assetType) => {
                if (this.utils.Type.isString(params?.CONTENT[assetType]) && this.utils.Type.isEmptyString(params?.CONTENT[assetType])) {
                    this?.logger?.log('normalizeParams:', assetType + ':', params?.CONTENT[assetType], '(empty string) Reset to undefined!');
                    params.CONTENT[assetType] = undefined;
                }
                switch (assetType) {
                    case AssetEmbedType.CID:
                        params.CONTENT[assetType] = undefined;
                        break;
                }
            });
        }
        return params;
    };
    mergeCallbacks = (existingCallbacks = {}, incomingCallbacks = {}) => {
        const overwriteExisting = incomingCallbacks?.overwrite || true;
        Object.keys(incomingCallbacks).forEach((incomingMethodName) => {
            switch (overwriteExisting) {
                case true:
                    if (this.utils.Type.isFunction(incomingCallbacks[incomingMethodName])) {
                        existingCallbacks[incomingMethodName] = incomingCallbacks[incomingMethodName];
                    }
                    break;
                default:
                    if (this.utils.Type.isNullOrUndefined(existingCallbacks[incomingMethodName])
                        &&
                            this.utils.Type.isFunction(incomingCallbacks[incomingMethodName])) {
                        existingCallbacks[incomingMethodName] = incomingCallbacks[incomingMethodName];
                    }
            }
        });
        return existingCallbacks;
    };
    namespaceConverter = (params) => {
        if (params?.TAG?.callback && this.utils.Type.isString(params?.TAG?.callback)) {
            params.TAG.callback = this.utils.DOM.getDeepVal(window, String(params?.TAG?.callback));
        }
        if (params?.TAG?.namespace) {
            Object.keys(params?.TAG?.namespace).forEach((key) => {
                if (this.utils.Type.isString(params?.TAG?.namespace[key])) {
                    params.TAG.namespace[key] = this.utils.DOM.getDeepVal(window, String(params?.TAG?.namespace[key]));
                }
            });
        }
        return params;
    };
}
